import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';
import {
  Button,
  Form,
  FormGroup,
  Label,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import { APIgetCollectionGroup } from '../../../api/Collections';

import ErrorBoundary from '../../ErrorBoundary';

class CollectionGroupSelectModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collectionGroup: '',
      loading: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSelectCollectionGroup = this.handleSelectCollectionGroup.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  getCollections() {
    const { collectionGroups } = this.props;
    const options = [];

    collectionGroups.forEach((cg) => {
      if (cg.id > 0) {
        options.push({
          value: cg.name,
          label: cg.name,
          uuid: cg.id,
        });
      }
    });

    return options;
  }

  handleChange(value) {
    this.setState({ collectionGroup: value });
  }

  handleSelectCollectionGroup() {
    const { collectionGroup } = this.state;
    const {
      handleCollectionGroupSelect,
      handleClose,
    } = this.props;

    if (!collectionGroup) {
      return;
    }

    this.setState({ loading: true });
    APIgetCollectionGroup(collectionGroup.uuid).then((response) => {
      const { data } = response;
      handleCollectionGroupSelect({
        type: 'group',
        uuid: data.id,
        name: data.name,
        featured_file: {
          width: 1200,
          height: 800,
          urls: {
            thumbnail: data.image,
            thumbnailx2: data.image,
            featured: data.image,
            thumbnailmasonry: data.image,
          },
        },
      });
      handleClose();
    });
  }

  handleKeyPress(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.handleSelectCollectionGroup();
    }
  }

  render() {
    const {
      intl,
      handleClose,
    } = this.props;
    const {
      collectionGroup,
      loading,
    } = this.state;

    return (
      <ErrorBoundary>
        <ModalHeader toggle={handleClose} className="modal-header-center">
          {intl.formatMessage({ defaultMessage: 'Select collection group' })}
        </ModalHeader>
        <ModalBody style={{ overflow: 'visible' }}>
          <Form
            className="select-collection-form"
            onChange={this.handleChange}
            onKeyPress={this.handleKeyPress}
          >
            <FormGroup>
              <Label for="selectCollectionGroup">
                {intl.formatMessage({ defaultMessage: 'Choose collection group' })}
              </Label>
              <Select
                id="selectCollectionGroup"
                inputId="selectCollectionGroupInput"
                isClearable
                options={this.getCollections()}
                onChange={this.handleChange}
                value={collectionGroup}
                isOptionSelected={(option, value) => {
                  if (value[0]) {
                    return option.uuid === value[0].uuid;
                  }
                  return false;
                }}
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter className="justify-r">
          <div className="buttons-group">
            <Button
              color="primary"
              disabled={loading || !collectionGroup}
              onClick={this.handleSelectCollectionGroup}
            >
              {loading ? intl.formatMessage({ defaultMessage: 'Wait...' }) : intl.formatMessage({ defaultMessage: 'Select collection group' })}
            </Button>
          </div>
        </ModalFooter>
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = state => ({
  collectionGroups: state.Collections.collectionGroups,
});

CollectionGroupSelectModal.propTypes = {
  intl: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  collectionGroups: PropTypes.array.isRequired,
  handleCollectionGroupSelect: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(injectIntl(CollectionGroupSelectModal));
